import { useAtomValue } from "jotai";

import { type Conversation } from "shared/apiClient";
import { showReportVar } from "@/variables/globalVar";

export function useHasDisclaimerBeenAccepted(
  conversation: Conversation | undefined | null,
) {
  const showReport = useAtomValue(showReportVar);
  return showReport.conversationId === conversation?.id && showReport.visible;
}
